export const PROJECT_MANAGER_REVIEW_DATA = [
    {
        id: 1,
        title: "Leadership & Accountability",
        definition: "Acts as the CEO of the project. Owns outcomes, not tasks.",
        questions: [
            "Consistently takes full ownership of project outcomes, not just tasks.",
            "Makes timely decisions without avoiding responsibility.",
            "Anticipates problems and acts before they escalate.",
            "Escalates issues early and appropriately instead of letting them become recurring problems on weekly scorecards.",
            "Sets and maintains professional standards on site.",
            "Holds trades and internal team accountable without drama.",
            "Protects LIDA’s reputation in every interaction.",
            "Is trusted by clients, trades, and internal team.",
            "Leads calmly under pressure.",
            "Acts as the clear leader and single point of accountability for the project."
        ]
    },
    {
        id: 2,
        title: "Planning & Schedule Management",
        definition: "Runs the project through a real, current, actively managed plan.",
        questions: [
            "Maintains a current, realistic master schedule at all times, as evidenced in weekly schedule reporting.",
            "Uses the schedule actively to drive the project, not just to report.",
            "Plans work weeks ahead, not days.",
            "Understands and manages the critical path.",
            "Coordinates long-lead items proactively.",
            "Sequences trades to avoid stacking and rework.",
            "Builds recovery plans when delays appear instead of allowing ongoing slippage to show up on weekly scorecards.",
            "Keeps key milestones and payment dates visible and managed.",
            "Rarely surprises the team or client with schedule issues.",
            "Delivers projects in line with the agreed schedule commitments."
        ]
    },
    {
        id: 3,
        title: "Financial Management & Budget Control",
        definition: "Manages the project like the money is their own.",
        questions: [
            "Understands the full project budget and cost structure.",
            "Keeps cost codes and WIP current and accurate, as reflected in weekly financial reporting.",
            "Flags potential overruns early instead of allowing budgets to first appear as over without change orders on weekly scorecards.",
            "Controls allowances tightly and transparently.",
            "Approves invoices critically and accurately and on time.",
            "Prevents scope creep from eroding margin.",
            "Understands the financial impact of delays and rework.",
            "Protects gross margin as if it were their own money.",
            "Communicates financial risks clearly and early.",
            "Delivers projects at or better than planned margin."
        ]
    },
    {
        id: 4,
        title: "Quality Control & Standards",
        definition: "Builds it right, not just fast.",
        questions: [
            "Inspects work proactively, not just at deficiencies.",
            "Catches issues before they get covered up.",
            "Holds trades to LIDA standards, not industry average.",
            "Uses checklists and systems for quality control.",
            "Prevents rework instead of managing it.",
            "Maintains clean, safe, professional sites, as reflected in site condition checks and weekly reporting.",
            "Protects long-term durability and performance of the home.",
            "Delivers clean, organized turnovers.",
            "Rarely has major deficiencies at possession.",
            "Is known for consistently high-quality projects."
        ]
    },
    {
        id: 5,
        title: "Client / Stakeholder Experience & Communication",
        definition: "Creates calm, trust, clarity, and confidence for clients and stakeholders.",
        questions: [
            "Sets clear expectations with clients at every stage.",
            "Provides consistent, timely, and clear communication, as reflected in weekly client update compliance.",
            "Runs organized and productive client meetings.",
            "Keeps Buildertrend and client-facing reports current and useful, as reflected in weekly scorecards.",
            "Communicates bad news early and professionally.",
            "Manages client emotions calmly and constructively.",
            "Prevents surprises for the client.",
            "Protects the relationship during stressful moments.",
            "Coordinates effectively with designers, consultants, and stakeholders.",
            "Clients and stakeholders would enthusiastically recommend them."
        ]
    },
    {
        id: 6,
        title: "Systems & Administrative Discipline",
        definition: "Runs projects through systems, not memory or heroics.",
        questions: [
            "Uses LIDA systems consistently and correctly.",
            "Keeps Buildertrend and documentation current, as reflected in weekly admin scorecards.",
            "Follows SOPs even when busy.",
            "Keeps schedules, budgets, and records accurate, as reflected in weekly reporting.",
            "Does not rely on memory or heroics.",
            "Completes required admin tasks on time, as reflected in performance points.",
            "Keeps project data auditable and reliable.",
            "Runs effective GSRs and internal meetings.",
            "Improves systems instead of working around them.",
            "Is a role model for process discipline."
        ]
    },
    {
        id: 7,
        title: "Risk Management & Problem Prevention",
        definition: "Prevents issues instead of reacting to them.",
        questions: [
            "Maintains a clear, signed-off project scope and drawing set.",
            "Enforces the change order process without exception.",
            "Explains cost and schedule impacts before proceeding with changes.",
            "Ensures no work proceeds on verbal changes.",
            "Keeps RFIs current, documented, and closed.",
            "Controls client decision timelines.",
            "Prevents small changes from becoming big problems.",
            "Keeps documentation clean and auditable.",
            "Rarely has disputes caused by unclear scope or changes.",
            "Protects both LIDA and the client through disciplined documentation."
        ]
    },
    {
        id: 8,
        title: "Resource & Team Coordination",
        definition: "Leads the full project team with clarity and authority.",
        questions: [
            "Builds strong, respectful relationships with key trades.",
            "Sets clear expectations before work starts.",
            "Holds firm but fair boundaries with trades and consultants.",
            "Resolves conflicts quickly and professionally.",
            "Does not tolerate chronic underperformance.",
            "Coordinates internal team effectively.",
            "Keeps momentum high even under pressure.",
            "Trades want to work on their projects.",
            "Gets priority service because of professionalism.",
            "Leads the extended project team effectively."
        ]
    },
    {
        id: 9,
        title: "Continuous Improvement & Professional Development",
        definition: "Improves themselves and the company every year.",
        questions: [
            "Is coachable and open to feedback.",
            "Actively works on self-improvement.",
            "Shares lessons learned with the team.",
            "Helps onboard or mentor others when needed.",
            "Seeks training and professional development.",
            "Supports and develops team members.",
            "Improves systems instead of working around them.",
            "Contributes positively to company culture.",
            "Represents LIDA professionally at all times.",
            "Raises the standard of the company, not just their projects."
        ]
    },
    {
        id: 10,
        title: "Alignment with LIDA Core Values & Culture",
        definition: "Lives and protects the LIDA way.",
        questions: [
            "Lives LIDA core values consistently.",
            "Protects LIDA standards even when under pressure.",
            "Acts in a way that creates a WOW experience for clients and team.",
            "Does what they say they are going to do.",
            "Is viewed as a culture carrier at LIDA.",
            "Treats team, trades, and clients with respect at all times.",
            "Represents LIDA’s professionalism in every setting.",
            "Contributes to a positive, accountable team environment.",
            "Is someone others want on their projects.",
            "Raises the bar for what “professional builder” means at LIDA."
        ]
    }
];
